import {
    Box,
    Container,
    HStack,
    Image,
    Stack,
    Text,
    useColorModeValue,
} from "@chakra-ui/react"
import { NavLink } from "react-router-dom"
import rapidLogo from "../images/rapidToolzLogo_2.png"
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation('signedOut')

    return (
        <Box
            bg={useColorModeValue("white", "gray.900")}
            color={useColorModeValue("gray.700", "gray.200")}
            bottom={0}
            right={0}
            left={0}
        >
            <Container
                as={Stack}
                maxW={"6xl"}
                py={4}
                spacing={4}
                justify={"center"}
                align={"center"}
            >
                <HStack spacing={4} mt={'2rem'}>
                    <Image src={rapidLogo} rounded={7.5} objectFit={'fill'} />
                </HStack>
                <Stack direction={"row"} spacing={6}>
                    <NavLink to={"/"}><Text _hover={{ textDecoration: "underline" }}>{t('home')}</Text></NavLink>
                    <NavLink to={"/features"}><Text _hover={{ textDecoration: "underline" }}>{t('features')}</Text></NavLink>
                    <NavLink to={"/pricing"}><Text _hover={{ textDecoration: "underline" }}>{t('pricing')}</Text></NavLink>
                    <NavLink to={"/free-trial"}><Text _hover={{ textDecoration: "underline" }}>{t('free_trial')}</Text></NavLink>
                    <NavLink to={"/aboutus"}><Text _hover={{ textDecoration: "underline" }}>{t('about_us')}</Text></NavLink>
                    <NavLink to={"/contactus"}><Text _hover={{ textDecoration: "underline" }}>{t('contact_us')}</Text></NavLink>
                    <NavLink to={"/help"}><Text _hover={{ textDecoration: "underline" }}>{t('help')}</Text></NavLink>
                </Stack>
            </Container>

            <Box
                borderTopWidth={1}
                borderStyle={"solid"}
                borderColor={useColorModeValue("gray.200", "gray.700")}
            >
                <Container
                    as={Stack}
                    maxW={"6xl"}
                    py={4}
                    direction={{ base: "column", md: "row" }}
                    spacing={4}
                    justify={{ base: "center", md: "space-between" }}
                    align={{ base: "center", md: "center" }}
                >
                    <Text>© 2025 RapidToolz. {t('all_rights_reserved')}</Text>
                </Container>
            </Box>
        </Box>
    )
}
